import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import './App.css';
import store from './Redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist'
import Protected from './Components/Protected';
import { MsalProvider } from '@azure/msal-react';
import Callback from './Pages/Callback';
import Forbidden from './Pages/Forbidden';
import NotiAuthorized from './Pages/NotAuthorized';
import Tasking from './Pages/Tasking';
import Login from './Pages/Login';
let persistor = persistStore(store);

function App({ msalInstance }) {
  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
              <Router>
                <Routes>
                  <Route exact path="/" element={ <Protected><Tasking/></Protected>} />
                  
                  <Route exact path="/login" element={<Login />} />
                  <Route exact path="/callback" element={<Callback />} />
                  <Route exact path="/NotAuthorized" element={<NotiAuthorized />} />
                  <Route exact path="/Forbidden" element={<Forbidden />} />
                </Routes>
              </Router>
        </PersistGate>
      </Provider>
    </MsalProvider>
  );
}

export default App;
